// @flow
import { push } from 'react-router-redux';
import { fetchMe } from './user.actions';

const ACCOUNTS_URL = '/api/projects/:id/accounts';
const WEB_PROPERTIES_URL = '/api/projects/:id/accounts/:accountId/webProperties';
const PROJECTS_URL = '/api/projects';
const PROJECT_URL = '/api/projects/:id';
const PROJECT_AVAILABLE_URL = '/api/projects/:id/enabled';

export const ACCOUNTS_UPDATED = 'accounts/UPDATED';
export const ACCOUNTS_UPDATING = 'accounts/UPDATING';
export const ACCOUNTS_FETCH_ERROR = 'accounts/ERROR';
export const ACCOUNTS_REMOVE = 'accounts/REMOVE';
export const OPEN_REMOVE_PROJECT_DIALOG = 'accounts/SHOW_REMOVE_DIALOG';
export const CLOSE_REMOVE_PROJECT_DIALOG = 'accounts/CLOSE_REMOVE_DIALOG';
export const OPEN_DISABLE_PROJECT_DIALOG = 'accounts/SHOW_DISABLE_DIALOG';
export const CLOSE_DISABLE_PROJECT_DIALOG = 'accounts/CLOSE_DISABLE_DIALOG';

export const PROPERTIES_UPDATED = 'properties/UPDATED';
export const PROPERTIES_CREATED = 'properties/CREATED';
export const PROPERTIES_UPDATING = 'properties/UPDATING';
export const PROPERTIES_CREATING = 'properties/CREATING';
export const PROPERTIES_FETCH_ERROR = 'properties/ERROR';

export const getAccounts = ({ cb, id }: { cb: Function, id: string }) => {
  const fetchUrl = ACCOUNTS_URL.replace(':id', `${id}`);
  return (dispatch: Function) => {
    dispatch({ type: ACCOUNTS_UPDATING });
    fetch(fetchUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => response.json().then((data) => ({ data, status: response.status })))
      .then(({ data, status }) => {
        if (status === 403) {
          return dispatch({ type: ACCOUNTS_FETCH_ERROR, data });
        }

        if (cb) cb.call(this, data);

        return dispatch({
          type: ACCOUNTS_UPDATED,
          data
        });
      });
  };
};

export const getWebProperties = ({ id, accountId }: { id: string, accountId: string }) => {
  const fetchUrl = WEB_PROPERTIES_URL.replace(':id', `${id}`).replace(':accountId', `${accountId}`);
  return (dispatch: Function) => {
    dispatch({ type: PROPERTIES_UPDATING });
    fetch(fetchUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => response.json().then((data) => ({ data, status: response.status })))
      .then(({ data, status }) => {
        if (status === 403) {
          return dispatch({ type: PROPERTIES_FETCH_ERROR, data });
        }

        return dispatch({
          type: PROPERTIES_UPDATED,
          data
        });
      })
      .catch((err) => {
        dispatch({ type: PROPERTIES_FETCH_ERROR, err });
      });
  };
};
export const createWebProperty = ({
  cb,
  id,
  accountId,
  data
}: {
  cb: Function,
  id: string,
  accountId: string,
  data: any
}) => (dispatch: Function) => {
  const fetchUrl = WEB_PROPERTIES_URL.replace(':id', `${id}`).replace(':accountId', `${accountId}`);

  dispatch({ type: PROPERTIES_CREATING });
  fetch(fetchUrl, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache'
    },
    credentials: 'include'
  })
    .then((response) => response.json().then((data) => ({ data, status: response.status })))
    .then(({ data }) => {
      const { success, error } = data;

      if (!success && error && error.isLimit) {
        window.location.href = `/auth/with-google/webproperty-balance?projectId=${id}`;
        return;
      }

      dispatch(
        fetchMe((userData) => {
          dispatch({
            type: PROPERTIES_CREATED,
            userData
          });

          if (cb) cb.call(this, userData);
        })
      );
    });
};

export const openDisableProjectDialog = ({ id }: { id: string }) => (dispatch: Function) =>
  dispatch({
    type: OPEN_DISABLE_PROJECT_DIALOG,
    data: id
  });

export const closeDisableProjectDialog = () => (dispatch: Function) =>
  dispatch({
    type: CLOSE_DISABLE_PROJECT_DIALOG
  });

export const openRemoveProjectDialog = ({ id }: { id: string }) => (dispatch: Function) =>
  dispatch({
    type: OPEN_REMOVE_PROJECT_DIALOG,
    data: id
  });

export const closeRemoveProjectDialog = () => (dispatch: Function) =>
  dispatch({
    type: CLOSE_REMOVE_PROJECT_DIALOG
  });

export const createProject = ({ cb }: { cb: Function }) => (dispatch: Function) => {
  const fetchUrl = PROJECTS_URL;

  fetch(fetchUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache'
    },
    credentials: 'include'
  })
    .then((response) => response.json().then((data) => ({ data, status: response.status })))
    .then(({ data }) => {
      const { _id } = data;

      dispatch(
        fetchMe(({ projects }) => {
          const idx = projects.indexOf(projects.find((p) => p._id === _id));
          dispatch(push(`/wizard/select-web-property?idx=${idx}`));

          if (cb) cb.call(this, data);
        })
      );
    });
};

export const enableProject = ({ id, cb }: { id: string, cb: Function }) => (dispatch: Function) => {
  const fetchUrl = PROJECT_AVAILABLE_URL.replace(':id', `${id}`);
  fetch(fetchUrl, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache'
    },
    credentials: 'include'
  })
    .then((response) => response.json().then((data) => ({ data, status: response.status })))
    .then(({ data }) => {
      dispatch(
        fetchMe(() => {
          if (cb) cb.call(this, data);
        })
      );
    });
};

export const disableProject = ({ id, cb }: { id: string, cb: Function }) => (
  dispatch: Function
) => {
  const fetchUrl = PROJECT_AVAILABLE_URL.replace(':id', `${id}`);
  fetch(fetchUrl, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache'
    },
    credentials: 'include'
  })
    .then((response) => response.json().then((data) => ({ data, status: response.status })))
    .then(({ data }) => {
      dispatch(
        fetchMe(() => {
          dispatch({
            type: CLOSE_DISABLE_PROJECT_DIALOG
          });

          if (cb) cb.call(this, data);
        })
      );
    });
};

export const deleteProject = ({ id, cb }: { id: string, cb: Function }) => (dispatch: Function) => {
  const fetchUrl = PROJECT_URL.replace(':id', `${id}`);
  fetch(fetchUrl, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache'
    },
    credentials: 'include'
  })
    .then((response) => response.json().then((data) => ({ data, status: response.status })))
    .then(({ data }) => {
      dispatch(
        fetchMe(() => {
          dispatch({
            type: CLOSE_REMOVE_PROJECT_DIALOG
          });

          if (cb) cb.call(this, data);
        })
      );
    });
};

export const saveRegex = ({
  id,
  userAgentRegexFilter
}: {
  id: string,
  userAgentRegexFilter: string
}) => (dispatch: Function) => {
  const fetchUrl = PROJECT_URL.replace(':id', `${id}`);
  fetch(`${fetchUrl}/filters`, {
    body: JSON.stringify({
      userAgentRegexFilter
    }),
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache'
    },
    credentials: 'include'
  })
    .then((response) => response.json().then((data) => ({ data, status: response.status })))
    .then(({ data }) => {
      dispatch(
        fetchMe(({ projects }) => {
          dispatch(push(`/projects`));
        })
      );
    });
};

export const setSeoPerfomanceEmails = ({
  id,
  cb,
  seoPerfEmails,
  sendSeoPerformanceEmail
}: {
  id: string,
  cb: Function,
  seoPerfEmails: string,
  sendSeoPerformanceEmail: boolean
}) => (dispatch: Function) => {
  const fetchUrl = PROJECT_URL.replace(':id', `${id}`);
  fetch(`${fetchUrl}/seo-perfomance`, {
    body: JSON.stringify({
      seoPerfEmails,
      sendSeoPerformanceEmail
    }),
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache'
    },
    credentials: 'include'
  })
    .then((response) => response.json().then((data) => ({ data, status: response.status })))
    .then(({ data }) => {
      dispatch(
        fetchMe(({ projects }) => {
          const idx = projects.indexOf(projects.find((p) => p._id === id));
          dispatch(push(`/projects?idx=${idx}`));

          if (cb) cb.call(this, data);
        })
      );
    });
};

export default {
  getAccounts,
  getWebProperties,
  createWebProperty,
  createProject,
  disableProject,
  enableProject,
  deleteProject,
  setSeoPerfomanceEmails,
  saveRegex,
  openRemoveProjectDialog,
  closeRemoveProjectDialog,
  openDisableProjectDialog,
  closeDisableProjectDialog
};



// WEBPACK FOOTER //
// ./src/actions/project.actions.js